$(document).ready(function(){
  $('.index-slider').slick({
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    arrows: false,
    dots: true,
    autoplay: true,
    autoplaySpeed: 2500,
  });
  $('.promotion-list-slider').slick({
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: false,
    dots: true,
    variableWidth: true,
  });
  $('.angel-slider').slick({
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: $('.angel-next'),
    prevArrow: $('.angel-prev'),
  });

  $('.hadiah-slider').slick({
    infinite: true,
    speed: 300,
    slidesToShow: 6,
    arrows: false,
    centerMode: true,
    variableWidth: true,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        infinite: true,
        dots: false
      }
    }
  ]
  });
});



var tabbed = $('.tabbed-content');
var tabHead = $('.tabbed-title');

tabHead.on('click', function(){
  tabHead.removeClass('tab-active');
  $(this).addClass('tab-active');
  var tabId = $(this).attr('id');
  tabbed.removeClass('tab-active');
  $('.'+tabId).addClass('tab-active');
})

var pointsBubble = $('.points-bubble');

$(window).scroll(function(){
  pointsBubble.css({
    animationName: 'bubbleanim'
  })
  $('.w50img').css({
    animationName: 'imganim'
  })
  $('.w50').css({
    animationName: 'divanim'
  })
  if ($(this).scrollTop() > 30) { // this refers to window
      $('.navbar-header').addClass('navbar-stick');
  }else{
    $('.navbar-header').removeClass('navbar-stick');
  }
})




//katalog
var katalogChoice = $('div.katalog-category > ul > li');
var katalogProducts = $('.katalog-products');
var katalogHeight = $('.katalog-products-container');
var katalogPagination = $('.katalog-pagination > ul > li');
var gridButton = $('.grid-button');
var initFilter = $('.initial-filter');

//init product position
if ($(window).width() > 800){
  $(document).ready(function(){
    var xspace = 0;
    var yspace = 0;
    var heightMultiplier = 0;
    var productLength = katalogProducts.length;
    console.log(productLength);

    for (var i = 0; i < productLength; i++) {
      katalogProducts.eq(i).css({
         transform: 'translateX('+xspace+'px) translateY('+yspace+'px)',
      });
      xspace = xspace + 240;
      if (xspace > 950) {
        xspace = 0;
        yspace = yspace + 280;
        heightMultiplier = heightMultiplier + 1;
      }
    }
    katalogHeight.css({
       height: heightMultiplier * 300,
       display: 'block'
    })
  })

  katalogChoice.on('click', function(){
    katalogChoice.removeClass('active-katalog');
    $(this).addClass('active-katalog');
    var choiceId = $(this).attr('class').split(' ')[0];
    console.log(choiceId);
    katalogProducts.addClass('jquery-hide');
    $('.katalog-' + choiceId).removeClass('jquery-hide');
    var heightMultiplier = 1;
    var xspace = 0;
    var yspace = 0;
    for (var i = 0; i < $('.katalog-' + choiceId).length; i++) {
       $('.katalog-' + choiceId).eq(i).css({
          transform: 'translateX('+xspace+'px) translateY('+yspace+'px)',
       });
       xspace = xspace + 240;
       if (xspace > 950) {
          xspace = 0;
          yspace = yspace + 280;
          heightMultiplier = heightMultiplier + 1;
       }
    }
    katalogHeight.css({
       height: heightMultiplier * 300,
       position: 'relative',
       opacity: 1,
       display: 'block'
    })
    $('.initial-filter').css({
       opacity: 0,
       position: 'absolute',
       zIndex: -99,
       width: '1000px'
    })
  })
  //new filter function
  gridButton.on('click', function(){
    var choiceId = $(this).attr('id');
    console.log(choiceId);

    katalogChoice.removeClass('active-katalog');
    $('.'+ choiceId).addClass('active-katalog');

    katalogProducts.addClass('jquery-hide');
    $('.katalog-' + choiceId).removeClass('jquery-hide');
    var heightMultiplier = 1;
    var xspace = 0;
    var yspace = 0;
    for (var i = 0; i < $('.katalog-' + choiceId).length; i++) {
       $('.katalog-' + choiceId).eq(i).css({
          transform: 'translateX('+xspace+'px) translateY('+yspace+'px)',
       });
       xspace = xspace + 240;
       if (xspace > 950) {
          xspace = 0;
          yspace = yspace + 280;
          heightMultiplier = heightMultiplier + 1;
       }
    }
    katalogHeight.css({
       height: heightMultiplier * 300,
       position: 'relative',
       opacity: 1,
       display: 'block'
    })
    $('.initial-filter').css({
      display: 'none',
    })
  })


  $('.reset').on('click', function(){
    // katalogProducts.removeClass('jquery-hide');
    // var xspace = 0;
    // var yspace = 0;
    // var heightMultiplier = 0;
    // var productLength = katalogProducts.length;
    // console.log(productLength);
    //
    // for (var i = 0; i < productLength; i++) {
    //   katalogProducts.eq(i).css({
    //      transform: 'translateX('+xspace+'px) translateY('+yspace+'px)',
    //   });
    //   xspace = xspace + 240;
    //   if (xspace > 950) {
    //     xspace = 0;
    //     yspace = yspace + 280;
    //     heightMultiplier = heightMultiplier + 1;
    //   }
    // }
    katalogHeight.css({
       height: 0,
       display: 'none',
    })
    $('.initial-filter').css({
      opacity: 1,
      position: 'relative',
      zIndex: 1,
      // width: '1000px'
      display: 'block',
    })
  })

  katalogPagination.on('click', function(){
    katalogPagination.removeClass('page-active');
    $(this).addClass('page-active');
  })
}

//katalog

//bantuan
var bantuanToggle = $('.bantuan-module');
var bantuanContent = $('.bantuan-content');

// bantuanToggle.on('click', function(){
//   bantuanContent.slideUp(500);
//   $(this).next().show(200);
// })

bantuanToggle.on('click', function(){
  bantuanToggle.removeClass('active');
  $(this).addClass('active');
})
//bantuan

//promotion
$('.promotion-button').on('click', function(){
  $(this).next().addClass('popup-show');
})

$('.popup').on('click', function(){
  $('.popup').removeClass('popup-show');
})
//promotion

//index
var tabContainer = $('.tabbed-container');

tabContainer.waypoint(function(){
  $('.w30').addClass('w30-active');
}, {offset: '50%'})
//index


$(".various-fancybox").fancybox();
var tabContainer = $('.tabbed-container');


//mobile
var mobileHandle = $('.mobile-handle');
var navBarOptions = $('.navbar-options');
var line1 = $('.line-1');
var line2 = $('.line-2');
var line3 = $('.line-3');

mobileHandle.on('click', function(){
  navBarOptions.toggleClass('navbar-active');
  mobileHandle.toggleClass('mobile-handle-active');
  line1.toggleClass('line-1-active');
  line2.toggleClass('line-2-active');
  line3.toggleClass('line-3-active');
})
//mobile
